'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactJplayerUtils = require('react-jplayer-utils');

var _constants = require('../util/constants');

exports.default = function (connectedJPlayers) {
  var jPlayers = (0, _reactJplayerUtils.initialState)(connectedJPlayers, _extends({}, _constants.defaultStatus, _constants.defaultOptions), 'options');

  return jPlayers;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplayer/lib/initialState/initialState.js
// module id = 726
// module chunks = 0